import { convertPhoneValue, translate, objectValueOrDefault, getPhoneValueAfterCountryChange, getPreloadedPrefix } from '@gig/magic-common';
import { __awaiter, __generator } from 'tslib';
import { ValidationDisplay } from '@gig/magic-form-builder';
import { getCountries } from '../utils/countries.js';

/**
 * Handles the change of the selected country for the phone field
 *
 * @param fieldConfig the form state
 * @returns a function that updates the phone prefix field value based on the selected country
 */
var onCountryChange = function (fieldConfig) { return function (value, state, setField) { return __awaiter(void 0, void 0, void 0, function () {
    var phoneTypeStateValue, countries, phoneValue, phoneHidden;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                phoneTypeStateValue = !!state.phone.value
                    ? state.phone.value
                    : '';
                return [4 /*yield*/, getCountries()];
            case 1:
                countries = _a.sent();
                return [4 /*yield*/, getPhoneValueAfterCountryChange(countries, phoneTypeStateValue, value)];
            case 2:
                phoneValue = _a.sent();
                phoneHidden = !objectValueOrDefault(fieldConfig.visibleForCountry, value);
                if (phoneValue) {
                    setField({
                        id: 'phone',
                        value: phoneValue,
                        touched: false,
                        isValidationPending: false,
                        hidden: phoneHidden,
                    });
                }
                return [2 /*return*/];
        }
    });
}); }; };
/**
 * Depending on selected phone prefix, it retrieves the correct phone number validator
 *
 * @param fieldConfig the form state
 * @returns the regexp string needed to validate the phone number
 */
function getPhoneValidator(fieldConfig) {
    return function (data) {
        var _a;
        var phoneValue = ((_a = data === null || data === void 0 ? void 0 : data.phone) === null || _a === void 0 ? void 0 : _a.value) || '';
        var phonePrefix = convertPhoneValue(phoneValue)[0];
        if (phonePrefix && fieldConfig.numberValidator[phonePrefix]) {
            return fieldConfig.numberValidator[phonePrefix];
        }
        return fieldConfig.numberValidator.DEFAULT;
    };
}
/**
 * Retrieves the custom prefixes from the field config and returns them as a string
 *
 * @param prefixes the list of prefixes to be displayed
 * @returns an object with prefixes as a comma-separated string
 */
function getCustomPrefixes(prefixes) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, {
                    prefixes: prefixes.join(','),
                }];
        });
    });
}
/**
 * Show error message for the phone field
 *
 * @returns the error message based on the phone field state
 */
function showErrorMessage() {
    return function (data) {
        var _a;
        if ((_a = data === null || data === void 0 ? void 0 : data.phone) === null || _a === void 0 ? void 0 : _a.error) {
            return translate('wandx-sign-up-notice.mismatch');
        }
        return translate('sign-up-step-two.phone.error');
    };
}
function phone(fieldConfig) {
    return __awaiter(this, void 0, void 0, function () {
        var countries;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getCountries()];
                case 1:
                    countries = _a.sent();
                    return [2 /*return*/, {
                            id: 'phone',
                            serverId: 'mobileNumber',
                            component: 'magic-ui-phone-number',
                            isDataField: true,
                            testId: 'step2-phone',
                            properties: {
                                'class': 'form-field',
                                'has-success': false,
                                'showErrorMessages': false,
                            },
                            dynamicProperties: {
                                'phone-validator': getPhoneValidator(fieldConfig),
                                'message': showErrorMessage(),
                            },
                            isStandAlone: true,
                            validationDisplay: ValidationDisplay.OnTouchShowMessage,
                            triggers: {
                                country: onCountryChange(fieldConfig),
                            },
                            preloadProperties: function () { return __awaiter(_this, void 0, void 0, function () {
                                var _a;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            if (!fieldConfig.customPrefixes) return [3 /*break*/, 2];
                                            return [4 /*yield*/, getCustomPrefixes(fieldConfig.customPrefixes)];
                                        case 1:
                                            _a = _b.sent();
                                            return [3 /*break*/, 4];
                                        case 2: return [4 /*yield*/, getPreloadedPrefix(countries)];
                                        case 3:
                                            _a = _b.sent();
                                            _b.label = 4;
                                        case 4: return [2 /*return*/, _a];
                                    }
                                });
                            }); },
                            converter: function (formValue) {
                                var _a;
                                var _b = convertPhoneValue((_a = formValue.phone) === null || _a === void 0 ? void 0 : _a.value), phonePrefix = _b[0], phone = _b[1];
                                return {
                                    mobileNumber: phone,
                                    mobilePrefix: phonePrefix,
                                };
                            },
                        }];
            }
        });
    });
}

export { phone };
